import { AnalyticsEvent } from '../../analytics.event';

export class PerformanceEvent extends AnalyticsEvent {
    constructor(action: string, duration: number, success: boolean) {
        super('performance_metric', {
            action: action,
            duration_ms: duration,
            success: success
        });
    }
}
